import {useParams, useRouteMatch} from 'react-router-dom';
import {UserApplications} from '../../../../../../../components/user-applications/user-applications';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import {ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';

export default function SeniorApplicationsProfessionalCaregiverOfficeScreen() {
  const officeContext = useOffice();
  let {id, entityId}: {id: string; entityId: string} = useParams();
  const {url} = useRouteMatch();
  const {t} = useTranslation();
  const userName = (officeContext.state.userForm?.user.displayName ||
    officeContext.state.userForm?.user.name)!;

  const {hasWritePermission} = useAuth();
  const canWriteApplications = hasWritePermission(
    RolePermissionType.Seniors_DigitalInclusion_Applications
  );

  return (
    <UserApplications
      caregiverMode={CaregiverMode.Professional}
      userId={id}
      userName={userName}
      entityId={entityId}
      applicationRowBaseLinkUrl={url}
      canWrite={canWriteApplications}
      headerTitleCrumbs={[
        {
          label: t(translations.screen_paths.professional_caregiver_seniors),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
        },
        {
          label: userName || '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
        },
        {
          label: t(translations.role_permissions_section['digital-inclusion']),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_DigitalInclusion}`,
        },
        {
          label: t(translations.screen_paths.senior_applications),
          link: url,
        },
      ]}
    />
  );
}
